<router-outlet></router-outlet>
<swb-alert></swb-alert>